export class FileSizeFormatter {
  static formatToGB(bytes) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      return `-`;
    }
    if (bytes === 0) {
      return `0`;
    }
    return `${(bytes / Math.pow(1024, Math.floor(3))).toFixed(1)}`;
  }

  static formatToMB(bytes) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      return `-`;
    }
    if (bytes === 0) {
      return `0`;
    }
    return `${(bytes / Math.pow(1024, 2)).toFixed(1)}`;
  }

  static formatToKB(bytes) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      return `-`;
    }
    if (bytes === 0) {
      return `0`;
    }
    return `${(bytes / Math.pow(1024, 1)).toFixed(1)}`;
  }
}
